<template>
    <div>

        <div class="slides" :class="isSlideForShop">
            <transition-group
                    name="slide"
                    mode="out-in"
                    enter-class="slide-in"
                    leave-class="slide-out"
                    enter-active-class=" slide-in-active"
                    leave-active-class=" slide-out-active"
            >
                <div
                        v-for="(file, index) in content.images"
                        v-if="checkIndex(index)"
                        :key="file.id"

                        class="text-center"
                        :class="isDivForShop"
                >



                    <a :href="file.absolute_url" v-if="file.absolute_url" target="_blank" ><img :src="'/img/store/' + file.nome_file"
                                                                              style=" width:94%;z-index:10000000"  ></a>
                    <a @click="modifyFile(file.id)" v-else><img :src="'/storage/' + file.nome_file" style="width:100%"></a>


                    <h5 v-if="file.description" class="abtg__carousel-description" v-html="file.description"></h5>

                    <a class="btn btn-sm   btn-block abtg__default-button abtg__orange-button" style="margin-top:-140px;" v-if="file.absolute_url">Scopri di più</a>
                </div>
            </transition-group>
        </div>
        <span
                class="prev"
                @click="move(-1)"
        >
    <i class="fas fa-chevron-left" aria-hidden="true"></i>
  </span>
        <span
                class="next"
                @click="move(1)"
        >
    <i class="fas fa-chevron-right" aria-hidden="true"></i>
  </span>


    </div>
</template>
<script>

    import {createHelpers} from 'vuex-map-fields';

    const {mapFields} = createHelpers({
        getterType: 'auction/getField',
        mutationType: 'auction/updateField',
    });

    export default {
        props: ['content'],
        components: {},
        data: function () {
            return {

                active: 0
            }

        },
        computed: {
            ...mapFields(['fileId']),
            isSlideForShop: function()
            {
                if(this.content.shop === true)
                {
                    return 'abtg__carousel-shopslide';
                }
            },

            isDivForShop: function()
            {
                if(this.content.shop === true)
                {
                    return 'abtg__carousel-divslide';
                }
            }
        },
        created: function () {

        },
        methods: {
            modifyFile: function (id) {
                this.fileId = id; // useful for deleteFile method
                this.$store.dispatch('auction/retrieveFile', id);
            },

            checkIndex: function (i) {
                if (Number(i) === Number(this.active)) {
                    return true;
                }
                return false;
            },
            move(amount) {
                // let newActive;
                // const newIndex = this.active + amount;
                // if (newIndex > parseInt(this.content.countImg)) newActive = 1;
                // if (newIndex === 0) newActive = parseInt(this.content.countImg);
                // //this.active = newActive || newIndex;
                this.active = this.active + amount;

                if (this.active == parseInt(this.content.countImg) || this.active == -1) {
                    this.active = 0;
                }
                console.log(this.active);
            },


        },


    }
</script>